/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState,useEffect } from "react";
import "../styles/Contact.css";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
    // Handle form submission, send data to server, etc.
  };
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top when this component mounts
  }, []);

  return (
    <div className="contact-page-container">
      <div className="contact-container">
        <div className="contact-info">
          <h2>Contact Information</h2>
          <p>Feel free to reach out to us via the following methods:</p>
          <p>
            Email:{" "}
            <a href="giftengptyltd@gmail.comL">giftengptyltd@gmail.com</a>
          </p>
          <p>
            Phone: <a href="tel:+27768486145">076 848 6145</a>
          </p>
          <p>
            LinkedIn:{" "}
            <a
              href="http://linkedin.com/in/gift-ntimani-baa916"
              target="_blank"
              rel="noreferrer"
            >
              Gift Ntimani
            </a>
          </p>
        </div>

        <div className="contact-section">
          <form className="contact-form" onSubmit={handleSubmit}>
            <h2>Get in Touch</h2>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>

      {/* Google Maps Integration */}
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3593.555760077162!2d28.06412747509664!3d-25.752200577357826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1ebfd7d320f14d6f%3A0xa8665007398ea73b!2s48%20Oliver%20Thambo%20St%2C%20Lotus%20Gardens%2C%20Pretoria%2C%200025!5e0!3m2!1sen!2sza!4v1728717176892!5m2!1sen!2sza"
          width="1400"
          className="map-iframe"
          height="450"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactPage;